import { MDXProvider } from '@mdx-js/tag';
import { graphql } from 'gatsby';
import MDXRenderer from 'gatsby-mdx/mdx-renderer';
import React from 'react';
import styled from 'styled-components';
import { Article } from '../article/article';
import { Wayfinder } from '../components/navigation/wayfinder';
import { Description } from '../description';
import { HeroImage } from '../image/image';
import { FeaturedTitle } from '../title/title';
import { media } from './config';
import { ornaments } from './ornaments';
import { Quote, typography } from './typography';

export default class WorkLayout extends React.Component {
  render() {
    // @ts-ignore
    const { data, children, ...props } = this.props;

    // @ts-ignore
    const { previous, next } = this.props.pageContext;
    const post = data.mdx;
    const fm = post.frontmatter;
    const image = fm.hero || fm.featuredImage;

    return (
      <MDXProvider
        components={{
          ...typography,
          ...ornaments
        }}
      >
        <Article>
          <HeroContainer>
            <Wayfinder next={next} previous={previous} />

            <ArticleTitle>
              <FeaturedTitle>{post.frontmatter.title}</FeaturedTitle>
            </ArticleTitle>

            <Description content={post.frontmatter.description} />

            {image && (
              <HeroImage
                className="heroImage"
                fluid={image.childImageSharp.fluid}
                alt={fm.title}
                title={fm.title}
                critical={true}
              />
            )}
          </HeroContainer>

          {post.frontmatter.quote && (
            <Quote
              dangerouslySetInnerHTML={{
                __html: post.frontmatter.quote
              }}
            />
          )}

          <MDXRenderer {...props}>{data.mdx.code.body}</MDXRenderer>
        </Article>
      </MDXProvider>
    );
  }
}

export const pageQuery = graphql`
  query($id: String!) {
    mdx(fields: { id: { eq: $id } }) {
      code {
        body
        scope
      }
      excerpt
      frontmatter {
        description
        date
        title
        quote
        featuredImage {
          publicURL
          childImageSharp {
            fluid(maxWidth: 2880) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        hero {
          publicURL
          childImageSharp {
            fluid(maxWidth: 2880) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

// =============================================================================

const HeroContainer = styled.span`
  position: relative;
  display: block;
  margin-bottom: 3rem;
`;

const ArticleTitle = styled.span`
  ${media.lg`
    position: absolute;
    right: 0;
    top: 50%;
    display: inline-block;
    transform: rotate(-22deg) translateY(-50%) translateX(10%);
    width: 50%;
    z-index: 2;
  `};
`;
